import { StateMachine } from 'chessboard/core/state/config/types';
import { addingMarkings } from 'chessboard/core/state/machine/states/adding-markings';
import { createUpdateParams } from 'chessboard/core/state/machine/create-update-params';
import { idle } from 'chessboard/core/state/machine/states/idle';
import { pieceDragging } from 'chessboard/core/state/machine/states/piece-dragging';
import { pieceSelected } from 'chessboard/core/state/machine/states/piece-selected';
import { promotionAreaShowing } from 'chessboard/core/state/machine/states/promotion/promotion-area-showing';

export const stateMachine = {
  /**
   * A set of functions that define how the params are updated in response
   * to side effects from any handled events
   */
  createUpdateParams,

  /**
   * We start in the board's Idle state
   */
  getCurrentState: () => StateMachine.States.Idle,

  /**
   * params are a state that is passed to each event handler function,
   * to provide context about the board.
   */
  getParams: () => ({
    draggingCoords: undefined,
    draggingPiece: undefined,
    markingStartSquare: undefined,
    promotionMove: undefined,
    selectedPiece: undefined,
  }),

  /**
   * The "pieces" state machine has four distinct states.
   *
   * 1. Idle: no piece is selected, or dragging, and the promotion
   *    window is closed.
   * 2. Dragging: a piece is being dragged.
   * 3. Selected: a piece is selected, but is resting on that same square.
   * 4. PromotionAreaShowing: self-explanatory.
   */
  states: {
    [StateMachine.States.AddingMarkings]: addingMarkings,
    [StateMachine.States.PieceDragging]: pieceDragging,
    [StateMachine.States.Idle]: idle,
    [StateMachine.States.PromotionAreaShowing]: promotionAreaShowing,
    [StateMachine.States.PieceSelected]: pieceSelected,
  },
} as StateMachine.Model;
